import React, { useState } from "react";
import { TextField } from "@mui/material";

import { addDoc, collection, doc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../api/firebase";
import { useDocumentData } from "react-firebase-hooks/firestore";

const AddTerm = ({ setOpen }) => {
  const [product, setProduct] = useState({
    content: "",
    error: "",
    loading: false,
  });
  const { content, error, loading } = product;

  // 値変更
  const handleChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
  };

  const [user] = useDocumentData(doc(db, "users", auth.currentUser.uid));

  const formatDateInYyyymmdd = (date) => {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const yyyy = y.toString();
    const mm = ("00" + m).slice(-2);
    const dd = ("00" + d).slice(-2);

    return yyyy + mm + dd;
  };
  function formatDateInHhmmss(date) {
    const h = date.getHours();
    const m = date.getMinutes();
    const s = date.getSeconds();

    const hh = ("00" + h).slice(-2);
    const mm = ("00" + m).slice(-2);
    const ss = ("00" + s).slice(-2);

    return hh + mm + ss;
  }

  const title = formatDateInYyyymmdd(new Date()) + formatDateInHhmmss(new Date());

  // 登録処理
  const setRequestDataShop = async (e) => {
    e.preventDefault();
    setProduct({
      ...product,
      error: "",
      loading: true,
    });
    try {
      // 変更処理
      const docRef = collection(db, "terms");
      await addDoc(docRef, {
        registered: user?.uid,
        registeredName: user?.lastName + user?.firstName,
        registeredAvatar: user?.avatar,
        isPublish: true,
        content,
        createdAt: serverTimestamp(),
        title,
      });

      // const docRef = await addDoc(collection(db, "ddp", match, "targets"), {
      //   [target]: {},
      // });

      setProduct({
        groupType: "",
        error: "",
        loading: false,
      });
      // window.location.reload();
      setOpen(false);
    } catch (err) {
      console.log(err);
      setProduct({
        ...product,
        error: err.message,
        loading: false,
      });
    }
  };

  return (
    <>
      <div>
        <div className="mb-3">利用規約を追加</div>
        <form onSubmit={setRequestDataShop}>
          {/* 提供する対象 */}
          <TextField
            id="outlined-required"
            name="content"
            label="利用規約内容"
            multiline
            rows={10}
            className=" w-full "
            onChange={handleChange}
            required
            disabled={loading}
          ></TextField>
          <div className="text-gray-400 text-md">
            ※下記「登録」を押下後、即利用者さんに通達されます。
          </div>
          {/* 登録ボタン */}
          <button
            data-mdb-ripple="true"
            data-mdb-ripple-color="light"
            className="inline-block px-6 py-2.5 mt-2 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
            disabled={loading}
            >
            {loading ? "送信しています..." : "登録"}
          </button>
          {error ? error : ""}
        </form>
      </div>
    </>
  );
};

export default AddTerm;
